import ManagedSolutionsPreview from "../../images/managed-solutions-preview.png"
import customBuildPathPreview from "../../images/custom-build-path-preview.png"
import {OrgBankingSetupState} from "../../services/orgBankingSetup"

export type BuildPathType = Exclude<OrgBankingSetupState, "NotSet">

export interface BuildPathOption {
	image: string
	title: string
	subtitle: string
	features: string[]
}

export const buildPathOptions: Record<BuildPathType, BuildPathOption> = {
	Custom: {
		image: customBuildPathPreview,
		title: "Platform",
		subtitle: "Build financial products with full control over the end customer experience",
		features: [
			"Build with direct access to the Federal Reserve, payment rails and card networks",
			"Operate multiple financial products on a single native ledger",
			"Run your product efficiently with Program Management",
		],
	},
	ReadyToLaunchBanking: {
		image: ManagedSolutionsPreview,
		title: "Managed Solutions",
		subtitle: "Embed pre-built financial products in one line of code.",
		features: [
			"Live in as quickly as 2 weeks",
			"Unit manages the operations including support and compliance",
			"Unit takes on all the risk and fraud exposure",
		],
	},
}

export function isBuildPathType(setup: OrgBankingSetupState | undefined): setup is BuildPathType {
	return setup !== "NotSet"
}
